export const getTutorProfileCompletionPercentage = (tutor, t) => {
  if (!tutor) return 0;

  const hasAnyTutoringType =
    Array.isArray(tutor?.tutoringType) &&
    (tutor.tutoringType.includes('REMOTE') || tutor.tutoringType.includes('IN_PERSON'));
  const isCalendarInactive =
    tutor?.currentStatus === t('tutorProfile.inActive') || tutor?.currentStatus === 'In Active';
  const isCalendarComplete = !!tutor?.currentStatus && !isCalendarInactive && hasAnyTutoringType;

  const sectionsToCheck = ['education', 'experience', 'calendar', 'location'];
  const completedSections = sectionsToCheck.filter((sectionId) => {
    switch (sectionId) {
      case 'education':
        return !!tutor?.education?.universityName;
      case 'experience':
        return !!tutor?.experience;
      case 'calendar':
        return isCalendarComplete;
      case 'location':
        return !!(tutor?.location && tutor?.rate);
      default:
        return false;
    }
  });

  return Math.round((completedSections.length / sectionsToCheck.length) * 100);
};

export const isTutorProfileComplete = (tutor, t) =>
  getTutorProfileCompletionPercentage(tutor, t) === 100;
